export enum AccumulatorClasses {
  HourlyYearBasedNormalAccumulator = 'HourlyYearBasedNormalAccumulator',
}

export enum PeriodizerClasses {
  DailyDecadePeriodizer = 'DailyDecadePeriodizer',
  HourlyYearPeriodizer = 'HourlyYearPeriodizer',
  QuarterHourPeriodizer = 'QuarterHourPeriodizer',
}
